import "./Notifications.scss";
import { useState, useEffect } from "react";
import { InputAdornment, TextField, useMediaQuery } from "@mui/material";
import ShowUser from "./../../assets/show-user.svg";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { NotificationsColumns } from "../../SourceData";
import MessageModals from "../../components/MessageModals/MessageModals";
import { DatePicker } from "antd";
import AddGif from "./../../assets/add-gif.gif";
import BlueButton from "../../components/BlueButton/BlueButton";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";
import moment from "moment";
const { RangePicker } = DatePicker;

const Notifications = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [query, setQuery] = useState("");
  const [view, setView] = useState("admins");
  const [currentModalView, setCurrentModalView] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    fetchNotifications();
  }, [query, dateRange, page, pageSize]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);

      // Build query parameters
      const params = new URLSearchParams({
        page: page + 1, // Convert 0-based to 1-based page numbering
        limit: pageSize, // Changed from per_page to limit based on your API response
      });

      // Add search query if exists
      if (query.length >= 2) {
        params.append("search", query);
      }

      // Add date range if selected
      if (dateRange) {
        if (dateRange[0]) {
          params.append("date_from", dateRange[0].format("YYYY-MM-DD"));
        }
        if (dateRange[1]) {
          params.append("date_to", dateRange[1].format("YYYY-MM-DD"));
        }
      }

      const res = await api.get(`/notifications?${params.toString()}`);
      setNotifications(res.data.data || []);
      setTotalRows(res.data.total || 0);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        // Reset to first page when search/filter changes
        setPage(0);
        fetchNotifications();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, dateRange]);

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/notifications/${id}`);
      fetchNotifications(); // Refresh the data after deletion
      setOpenDelete(false);
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      headerAlign: "right",
      align: "left",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="cell-action" style={{ justifyContent: "flex-end" }}>
            <Link
              className="cell-btn"
              onClick={() => {
                setSelectedNotificationId(params.row.id);
                setSelectedNotification(params.row);
                handleOpen("viewNotification");
              }}
            >
              <img src={ShowUser} alt="" />
            </Link>
            {/* <div
              className="cell-btn"
              onClick={() => {
                setSelectedNotificationId(params.row.id);
                setOpenDelete(true);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div> */}
          </div>
        );
      },
    },
  ];

  return (
    <div className="users">
      <div className="special-header">
        <p className="title">الاشعارات</p>
        <div className="actions-container">
          <div className="search">
            <TextField
              id="outlined-search"
              type="search"
              value={query}
              placeholder={
                view === "admins"
                  ? "ابحث بالاسم او البريد الالكتروني او رقم الموبايل"
                  : "بحث..."
              }
              onChange={handleSearchChange}
              sx={{
                width: isMobile
                  ? "100%"
                  : isTablet || view === "permissions"
                  ? "300px"
                  : "360px",
                borderRadius: "8px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />

            <RangePicker
              format={"MMM D"}
              style={{
                width: isMobile ? "100%" : isTablet ? "200px" : "300px",
                padding: "0px 10px",
                direction: "ltr",
              }}
              placeholder={["من", "الي"]}
              className="range-picker"
              onChange={handleDateRangeChange}
            />
          </div>

          <BlueButton
            text="اضافة اشعار جديد"
            size={isMobile ? "full" : isTablet ? "fit" : "large"}
            variant="fill"
            icon={<img src={AddGif} alt="" />}
            path="/notifications/create"
          />
        </div>
      </div>

      <div className="container">
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={NotificationsColumns.concat(actionColumn)}
          rows={notifications?.map((row, index) => {
            return { ...row, index: index + 1 };
          })}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          loading={loading}
          paginationMode="server"
          rowCount={totalRows}
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page,
            pageSize,
          }}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </div>

      <MessageModals
        open={openDelete}
        currentView="delete"
        onClose={() => {
          setOpenDelete(false);
        }}
        onConfirm={() => {
          handleDelete(selectedNotificationId);
        }}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        selectedNotification={selectedNotification}
      />
    </div>
  );
};

export default Notifications;
